export const normalizeTextAreaChangeEvent = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
  const normalizedEvent = { ...e, target: { ...e.target, value: e.target.value.normalize() } };

  return normalizedEvent;
};
